import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
const API_BASE = process.env.REACT_APP_BACKEND_URL || "http://3.236.217.225:5001/api";

export default function ResultadosEleccion({ eleccionId }) {
  const { token } = useAuth();
  const [resultados, setResultados] = useState([]);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fetchResultados = async () => {
      try {
        const res = await axios.get(`${API_BASE}/elecciones/resultados/${eleccionId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setResultados(res.data);
      } catch (err) {
        setMensaje(err.response?.data?.message || "Resultados no disponibles");
      }
    };
    fetchResultados();
  }, [eleccionId, token]);

  return (
    <div>
      <h3>Resultados</h3>
      {mensaje && <p>{mensaje}</p>}
      {resultados.map((r) => (
        <div key={r.candidato_id} style={{ marginBottom: 5 }}>
          <img src={r.foto || `https://ui-avatars.com/api/?name=${r.nombre}`} alt={r.nombre} width={50} style={{ marginRight: 10 }} />
          <span>{r.nombre} - {r.total_votos} votos</span>
        </div>
      ))}
    </div>
  );
}
